import state from '~store/modules/auth/state'
import actions from '~store/modules/auth/actions'

export default {
  state,
  actions
}
